import {
  Box,
  Container,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";

import Logo from "../assests/vedicwin.webp";

const socialLinks = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/vedicwin/",
    icon: <InstagramIcon sx={{ fontSize: 26 }} />,
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61592647318559",
    icon: <FacebookRoundedIcon sx={{ fontSize: 26 }} />,
  },
];

export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: "#102B6B", color: "#fff" }}>
      <Container
        maxWidth="xl"
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "1.7fr 1fr 1fr",
            },
            gap: { xs: 4, md: 6 },
            alignItems: {
              xs: "flex-start",
              md: "center",
            },
          }}
        >
          {/* Logo Section */}
          <Box>
            <Box
              component="img"
              src={Logo}
              alt="VedicWin Logo"
              sx={{
                width: 160,
                mb: 2,
              }}
            />

            <Typography
              variant="body2"
              sx={{
                maxWidth: 340,
                color: "rgba(255,255,255,0.75)",
                lineHeight: 1.8,
              }}
            >
              Building bright futures with focused learning and thoughtful
              guidance.
            </Typography>
          </Box>

          {/* Address */}
          <Box>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ mb: 1 }}
            >
              Office Address
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "rgba(255,255,255,0.75)",
                lineHeight: 2,
              }}
            >
              14-1-211/434, Parvath Nagar,
              <br />
              Near HITEC City,
              <br />
              Hyderabad, Telangana - 500018.
            </Typography>
          </Box>

          {/* Follow Us */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: {
                xs: "flex-start",
                md: "center",
              },
              justifySelf: {
                xs: "start",
                md: "end",
              },
              mt: {
                xs: 0,
                md: -2,
              },
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                mb: 2,
                lineHeight: 1.2,
              }}
            >
              Follow Us
            </Typography>

            <Stack direction="row" spacing={2}>
              {socialLinks.map(({ label, href, icon }) => (
                <IconButton
                  key={label}
                  component="a"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  sx={{
                    width: 52,
                    height: 52,
                    color: "#fff",
                    border: "2px solid rgba(255,255,255,0.4)",
                    "&:hover": {
                      bgcolor: "#FF6B00",
                      borderColor: "#FF6B00",
                    },
                  }}
                >
                  {icon}
                </IconButton>
              ))}
            </Stack>
          </Box>
        </Box>

        <Divider
          sx={{
            my: 4,
            borderColor: "rgba(255,255,255,0.15)",
          }}
        />

        <Typography
          align="center"
          variant="body2"
          sx={{
            color: "rgba(255,255,255,0.65)",
          }}
        >
          © {new Date().getFullYear()} VedicWin Tuition Center. All rights
          reserved.
        </Typography>
      </Container>
    </Box>
  );
}